import $ from "jquery";

var lastScrollPosition = 0;

function navigationToggle(currentScrollPosition) {
  var currentScrollPosition = window.scrollY;

  // Close all 
  $(this).closest("li").removeClass('menu-active');
  $('body').removeClass('header-scrolling');
  $('body').removeClass('dropdown-open');
  $('.nav_desktop_b4ba__navbar').removeClass('switch-white');
  $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
  $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
  $('.fadeout').hide();
  // end close all


  $('.nav_desktop_b4ba').css('opacity', 1);
  $('.nav_mobile_e3f1').css('opacity', 1);
    
  if (currentScrollPosition < 100) {
    $('.nav_desktop_b4ba').css('opacity', 1);
    $('.nav_mobile_e3f1').css('opacity', 1);
    $('body').removeClass('header-scrolling');
  } else {
    $('body').addClass('header-scrolling');

    if (currentScrollPosition < lastScrollPosition) {
      // Scrolling up
     // console.log('scrolling up')
      $('.nav_desktop_b4ba__navbar').addClass('switch-mint');
      $('.nav_desktop_b4ba__navbar').removeClass('switch-white');
      $('.nav_desktop_b4ba').css('opacity', 1);
      $('.nav_mobile_e3f1').css('opacity', 1);
    } else {
      // Scrolling down
  
     // console.log('scrolling down' )
      $('.nav_desktop_b4ba__navbar').removeClass('switch-mint');
      $('.nav_desktop_b4ba__navbar').addClass('switch-white');
      $('.nav_desktop_b4ba').css('opacity', 0);
      $('.nav_mobile_e3f1').css('opacity', 0);
    }
  }

  lastScrollPosition = currentScrollPosition;
}

window.addEventListener("scroll", function(){
  navigationToggle();
});

navigationToggle();

// dropdown-mega
var navHeight = $('.nav_desktop_b4ba').height();
$('.nav_desktop_b4ba__spacer').css({'height': navHeight + 'px'})

// dropdown-mega
$('.nav_desktop_b4ba__menu .menu_item').on('mouseenter', function(){
  var $li = $(this);

  if ($li.hasClass('dropdown_mega')) {
    var data_dropdown_mega = $li.attr('data-dropdown-mega');

    $('body').addClass('dropdown-open');

    $('.nav_desktop_b4ba__navbar').addClass('switch-white');
    $(this).closest("li").addClass('menu-active');

    $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
    $('.nav_desktop_b4ba__dropdown_megas [data-dropdown-mega="' + data_dropdown_mega + '"]').addClass('show_dropdown_mega');
    $('.fadeout').show();
  } else {
    $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
    $('.fadeout').hide();
  }
});

// leave nav
$('.nav_desktop_b4ba').on('mouseleave', function(){
  $(this).closest("li").removeClass('menu-active');
  $('body').removeClass('header-scrolling');
  $('body').removeClass('dropdown-open');
  $('.nav_desktop_b4ba__navbar').removeClass('switch-white');
  $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
  $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
  $('.fadeout').hide();
  navigationToggle();
});

$('.nav_desktop_b4ba__menu .menu_item').on('mouseleave', function(){
  $(this).closest("li").removeClass('menu-active');
});
